export default __webpack_public_path__ + "alberta-hammer-outline.4e02b4a9417d66094f37.svg";